const COLORS = ["#14F195", "#9945FF", "#00FFD1", "#ffffff"];

export function burstConfetti(x, y) {
  for (let i = 0; i < 26; i++) {
    const bit = document.createElement("span");
    bit.className = "confetti-bit";
    const angle = Math.random() * Math.PI * 2;
    const dist = 60 + Math.random() * 140;
    bit.style.left = `${x}px`;
    bit.style.top = `${y}px`;
    bit.style.background = COLORS[i % COLORS.length];
    bit.style.setProperty("--cx", `${Math.cos(angle) * dist}px`);
    bit.style.setProperty("--cy", `${Math.sin(angle) * dist - 40}px`);
    bit.style.setProperty("--cr", `${Math.random() * 720 - 360}deg`);
    if (i % 3 === 0) bit.style.borderRadius = "50%";
    document.body.appendChild(bit);
    setTimeout(() => bit.remove(), 950);
  }
}
